import { Component, ContentChildren, OnDestroy, QueryList } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatOption } from '@angular/material/core'
import { MatFormFieldControl } from '@angular/material/form-field'
import { filter, startWith, Subject, takeUntil, tap } from 'rxjs'

import { CustomMaterialInputControlComponent } from '../custom-field'

@Component({
  selector: 'mmx-searchable-select',
  templateUrl: './searchable-select.component.html',
  styleUrls: ['./searchable-select.component.scss'],
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: SearchableSelectComponent,
    },
  ],
  standalone: false,
})
export class SearchableSelectComponent
  extends CustomMaterialInputControlComponent<string>
  implements OnDestroy
{
  @ContentChildren(MatOption, { descendants: true })
  public queryOptions: QueryList<MatOption>
  public searchControl = new FormControl<string | null>(null)
  public searching = false
  private onDestroy$ = new Subject<void>()
  public filteredOptions$ = this.searchControl.valueChanges.pipe(
    takeUntil(this.onDestroy$),
    startWith(''),
    filter(() => this.queryOptions?.length > 0),
    tap((search) => {
      for (const option of this.queryOptions) {
        const $el = option._getHostElement()
        const show = !search || option.viewValue.toLowerCase().includes(search)
        $el.classList.toggle('hidden', !show)
      }
    }),
  ).subscribe()

  ngOnDestroy(): void {
    super.ngOnDestroy()
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
